import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { DeliveryAreaService } from '../../../../../delivery-area.service';
import { SessionFeedback } from '../session-feedback-view.part';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, areaService: DeliveryAreaService): GridSetup<SessionFeedback> {

	const staffPermissions = areaService.staffPermissions();
	return {
		rowName: { singular: 'Session Feedback', plural: 'Session Feedbacks' },
		getRowKey: row => '' + row.accSessionSurveyResponseId,
		stateKey: 'delivery-session-feedback-grid',
		actions: [],
		buttons: [],
		columns: getColumns(util),
		downloadOptions: {
			canDownload: staffPermissions.canDownloadProgramData,
			canDownloadPersonalInfo: staffPermissions.canDownloadProgramDataWithPersonalInfo,
			fileName: `${areaService.selectedTrimesterName()}-Session-Feedbacks`
		}
	}
}
